export default __webpack_public_path__ + "static/media/Clock.a87d7c6c.svg";